import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import type { PropsType } from '@components/BenefitsLandingPage'
import { openSubscribe } from '../actions/navigationActions'
import { dismissIntercom } from '@services/intercom'
import PrideLandingPage from '@components/PrideLandingPage'

function LandingPage (_props: PropsType): React.ReactNode {
  React.useEffect((): void => {
    dismissIntercom()
  }, [])
  return (
    <>
      <GlobalStyle backgroundColor={colors.white} />
      <HtmlHead
        title={`Dipsea | Get lost in a steamy fantasy world`}
        description={
          'Get access to the entire Dipsea library to explore 1,000+ sexy audio stories, soothing sleep scenes, steamy POV role-plays, and more. '
        }
      />
      <PrideLandingPage color={'pink'} inlineSubscribe={true}/>
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {
    openSubscribe: (): void => dispatch(openSubscribe())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage) as any) as any
